var _path, _circle, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayrollProcess(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1351 7.68863H13.7628V5.7743C13.7628 4.50577 13.2669 3.29489 12.3674 2.39539C11.4679 1.49588 10.2685 1 9 1C7.73147 1 6.52059 1.50741 5.63262 2.39539C4.73311 3.29489 4.23723 4.50577 4.23723 5.7743V7.68863H2.86491C2.39209 7.68863 2 8.08073 2 8.55354V18.5865C2 19.0708 2.39209 19.4514 2.86491 19.4514H15.1351C15.6079 19.4514 16 19.0708 16 18.5865V8.55354C16 8.08073 15.6079 7.68863 15.1351 7.68863ZM5.96705 5.7743C5.96705 4.96705 6.28995 4.1944 6.85502 3.61779C7.4201 3.05272 8.19275 2.72982 9 2.72982C9.80725 2.72982 10.5799 3.05272 11.145 3.61779C11.7216 4.1944 12.0329 4.96705 12.0329 5.7743V7.68863H5.96705V5.7743Z",
    fill: "#5E5E66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 6,
    fill: "#10B07C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12 18.0609 12.4214 19.0783 13.1716 19.8284C13.9217 20.5786 14.9391 21 16 21C17.0609 21 18.0783 20.5786 18.8284 19.8284C19.5786 19.0783 20 18.0609 20 17C20 15.9391 19.5786 14.9217 18.8284 14.1716C18.0783 13.4214 17.0609 13 16 13C14.9391 13 13.9217 13.4214 13.1716 14.1716C12.4214 14.9217 12 15.9391 12 17Z",
    fill: "#10B07C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9076 15.5L15.3298 18.4997M15.3287 18.5L14 16.9537",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollProcess);
export default __webpack_public_path__ + "static/media/payroll-process.0280e409.svg";
export { ForwardRef as ReactComponent };